import React from 'react'
import SignUp from '../../components/Account/SignUp'

const SignUpPage = () => {
  return (
    <div>
        <SignUp />
    </div>
  )
}

export default SignUpPage